import Splide from "@splidejs/splide"
import { qsa } from "./utils"

export const initSlider = () => {
  const sliders = qsa("[data-slider]")

  sliders.forEach((slider) => {
    const splide = new Splide(slider, {
      type: "loop",
      pagination: false,
      width: "100%",
      padding: "calc((100% - min(var(--content-width), 80%)) / 2)",
      autoHeight: true,
      lazyLoad: "nearby",
      gap: "1.5rem",
      snap: true,
      autoplay: true,
      preloadPages: 2,
      // updateOnMove:true,
      mediaQuery: "min",
      breakpoints: {
        640: {
          heightRatio: 0.5625,
          autoHeight: false,
        },
      },
    })

    splide.mount()
  })
}
